<template>
  <div
    class="empty-cont-wrap"
    :class="{ 'h5-empty-wrap': isH5, 'electron-empty-wrap': isElectron }"
  >
    <div class="cont-wrap">
      <img :src="emptyImgUrl" alt="" />
      <span class="tips">{{ tips }}</span>
      <button @click="jumpHome" class="operate-btn">回到主页</button>
    </div>
  </div>
</template>

<script>
import { isH5, isHXApp } from "@saas/components/src";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { getMoguoCdnUrl } from "../../utils/assets";
export default {
  data: function () {
    return {
      isH5: false,
      isHXApp: false,
      tips: "抱歉！本课程已被教师删除",
      isElectron: window.isElectron,
    };
  },
  computed: {
    emptyImgUrl() {
      return getMoguoCdnUrl("/cdn/static/images/empty.png");
    },
  },
  mounted() {
    this.isH5 = isH5();
    this.isHXApp = isHXApp();
    if (this.$route.query?.tips) {
      this.tips = this.$route.query.tips;
    }
  },
  methods: {
    jumpHome() {
      if (this.isHXApp) {
        jsToFlutter("toMain", { index: 0 });
      } else if (window.isElectron) {
        this.$router.push("/");
      } else {
        window.location.href = "/";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-cont-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  .cont-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .tips {
    font-weight: 400;
    font-size: 14px;
    color: #515350;
    line-height: 20px;
    padding: 20px 0;
  }
  img {
    width: 200px;
  }
  .operate-btn {
    width: 70px;
    height: 30px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 8px;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
  }
}
.empty-cont-wrap.h5-empty-wrap {
  .tips {
    font-weight: 400;
    font-size: 0.37rem;
    color: #515350;
    line-height: 0.53rem;
    padding: 0.35rem 0;
  }
  img {
    width: 5rem;
  }
  .operate-btn {
    width: 2.13rem;
    height: 0.91rem;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 0.21rem;
    font-weight: 500;
    font-size: 0.37rem;
    color: #ffffff;
    line-height: 0.91rem;
    text-align: center;
  }
}
.empty-cont-wrap.electron-empty-wrap {
  height: calc(100vh - #{$nav-height});
}
</style>
